const devConfig = {
  apiRoot: "https://connect.halcyon.fm/graphql",
  checkoutUrl: "https://connect.halcyon.fm/start_checkout",
};

export default devConfig;
